import { ActionBar, Layout, ModalView, PageMotion, PoweredBy, useModalView, ViewSwitcher } from "components";
import { usePartialState } from "hooks";
import { IStatefulUI, PageProps } from "interfaces";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { when } from "utils";

export interface PaymentProps extends PageProps {}
export interface ViewProps extends PaymentProps, IStatefulUI<IState> {}

interface IState {
  data: any[];
  totalCount: number;
  page: number;
}

// TODO: Fetch users transfer history
export function Transfers(_props: PaymentProps) {
  const [state, set] = usePartialState<IState>();

  const fetchTransfers = async () => {
    set({ data: [], totalCount: 0, page: 1 });
  };

  useEffect(() => {
    fetchTransfers();
  });

  return (
    <PageMotion key="Payment" px="4px">
      <Layout>
        <ModalView>
          <Title />

          <ViewSwitcher>{state.totalCount || null}</ViewSwitcher>
        </ModalView>
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
}

function Title(props: any) {
  const navigate = useNavigate();
  const { hasPrev } = useModalView();

  const handleBack = () => {
    navigate(-1);
  };

  return <ActionBar onBackClick={handleBack} title="Transfers" _back={{ visibility: when(hasPrev, "visible", "hidden") }} />;
}
